// LIBRARY
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Select } from 'antd';

// CONSTANTS
const { Text } = Typography;
const { Option } = Select;

class PhleboPager extends React.Component {
	render() {
		const { pageSize, pageTotal, handleChangeSize, pagerTitle, currentPage } = this.props;

		const minPage = (currentPage * pageSize) + 1 - pageSize;
		const maxPage = currentPage * pageSize;

		const items = (() => {
			if (pageTotal === 0) {
				return `Showing 0 results`;
			} else if (pageTotal <= maxPage) {
				return `Showing ${minPage} - ${pageTotal} items out of ${pageTotal} results`;
			} else {
				return `Showing ${minPage} - ${maxPage} items out of ${pageTotal} results`;
			}
		})();

		return (
			<div className="table-title">
				<div>
					<Text strong>{pagerTitle}</Text>
				</div>
				<div>
					<div className="left">
						<Text>{items}</Text>
					</div>
					<div className="right">
						<Text>Display per page</Text>
						<Select
							size="small"
							value={pageSize}
							style={{ marginLeft: 10 }}
							onChange={handleChangeSize}
						>
							<Option value={5}>5</Option>
							<Option value={10}>10</Option>
							<Option value={15}>15</Option>
							<Option value={20}>20</Option>
						</Select>
					</div>
				</div>
			</div>
		);
	}
}

PhleboPager.propTypes = {
	handleChangeSize: PropTypes.func.isRequired,
	pageTotal: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	currentPage: PropTypes.number,
	pagerTitle: PropTypes.string,
};

PhleboPager.defaultProps = {
	pagerTitle: 'SEARCH RESULTS',
	currentPage: 1,
};

export default PhleboPager;
